<template>
    <v-row>
      <v-col cols="12">
          <sale-modifier-per-day-card> </sale-modifier-per-day-card> 
      </v-col>
    </v-row>
  </template>
  <script>
  import SaleModifierPerDayCard from "@/components/report/SaleModifierPerDayCard";
  
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Sales Modifier Per Day",
    },
  
    components: {
        SaleModifierPerDayCard
    },
  
    data() {
      return {
      };
    },
  };
  </script>